export default __webpack_public_path__ + "static/footer-logo-icon-7194f73d7ccad0bf86279ca6f239e9df.svg";